import { isPending } from "App/apiMiddleware";
import { connect } from "react-redux";
import { NAMESPACE } from "../constants";
import actionCreators from "../redux/actionCreators";
import actionTypes from "../redux/actionTypes";
import VersionInfo from "./versionInfo";
const mapStateToProps = (state) => ({
    inProgress: isPending(state, actionTypes.GET_VERSION_INFO),
    versionInfo: state[NAMESPACE].versionInfo
});
const mapDispatchToProps = (dispatch) => ({
    getVersionInfo: () => dispatch(actionCreators.getVersionInfo())
});
export default connect(mapStateToProps, mapDispatchToProps)(VersionInfo);
